const uploadTriggers = document.querySelectorAll('[data-upload-target]');
uploadTriggers.forEach(function (element) {
    new PhotoUploader({
        endpoint: element.dataset.endpoint,
        meta: {
            category: element.dataset.category,
        },
        target: element,
        doNotReload: true,
        allowedFileTypes: ['image/*', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        localToUse: 'files_locale',
    });
});

const deleteDocumentLinks = document.querySelectorAll('[data-delete-document]');
deleteDocumentLinks.forEach(function (deleteDocumentLink) {
    deleteDocumentLink.addEventListener('click', () => {
        const documentPath = deleteDocumentLink.dataset.documentPath;
        const url = deleteDocumentLink.dataset.url;

        deleteDocument(url, { document_path: documentPath })
            .then((data) => {
                if (typeof data.message !== 'undefined') {
                    alert(data.message);
                } else {
                    const documentContainerId = deleteDocumentLink.dataset.documentContainer;
                    const documentContainer = document.getElementById(documentContainerId);
                    if (documentContainer) {
                        documentContainer.remove();
                    }
                }
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error('Error:', error);
                alert('Kan het bestand niet verwijderen!');
            });
    });
});

const reportedToInsuranceElements = document.querySelectorAll('[name="reported_to_insurance"]');
reportedToInsuranceElements.forEach(reportedToInsuranceElement => reportedToInsuranceElement.addEventListener('change', () => {
    showReportedToInsuranceExplanationContainer(reportedToInsuranceElement.value === '1');
}));

window.onload = (event) => {
    const reportToInsurance = document.getElementById('reported_to_insurance1');
    if (reportToInsurance && reportToInsurance.checked) {
        showReportedToInsuranceExplanationContainer(true);
    }
};

function showReportedToInsuranceExplanationContainer (show) {
    const reportedToInsuranceExplanationContainer = document.getElementById('reported_to_insurance_explanation_container');
    reportedToInsuranceExplanationContainer.style.display = show ? 'block' : 'none';
}

async function deleteDocument (url = '', data = {}) {
    const response = await fetch(url, {
        credentials: 'same-origin',
        method: 'DELETE',
        headers: new Headers({
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }),
        body: JSON.stringify(data),
    });

    return await response.json();
}